export interface AppNoticeDetail {
  message: string
  tone?: 'info' | 'error'
  /** Optional path the notice can reveal in the system file manager. */
  revealPath?: string
  /** Optional button, such as Undo, that runs once and closes the notice. */
  action?: { label: string; run: () => void }
  /** A second button, shown before `action`. */
  secondary?: { label: string; run: () => void }
}

export function showNotice(detail: AppNoticeDetail) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<AppNoticeDetail>('app:notice', { detail }))
}
